/**
 * jQuery-free call tracking bootstrapper loaded outside WP Rocket's delayed bundle.
 */

/**
 * jQuery-free source tracking library.
 *
 * Usage:
 * var sourceTracker = window.TrimarkCreateSourceTracker({
 *   strategy: 'ft',
 *   cookie: {
 *     name: { ft: 'trmk_src_first', lt: 'trmk_src_last' },
 *     opts: { expires: 1, path: '/' },
 *   },
 *   forms: { prefillAttr: 'data-prefill' },
 * });
 * sourceTracker.init();
 * sourceTracker.populateFormFields();
 *
 * @param {object} settings
 * @returns {object} SourceTracker module
 */
window.TrimarkCreateSourceTracker = function (settings) {
	var module = {
		settings: settings,
		hasInit: false,
		init: function () {
			if (this.hasInit) {
				console.warn('SourceTracker has already been initialized.');
				return;
			}

			if (typeof Cookies === 'undefined') {
				console.warn('Please install js-cookie library to enable the SourceTracker library.');
				return;
			}

			this.hasInit = true;
			this.setSourceCookies();
			window.TrimarkSourceTracker = this;
			document.dispatchEvent(new CustomEvent('trmk:source-tracker-initialized'));
		},
		getSourceData: function () {
			var cookieName = this.settings.cookie.name[this.settings.strategy];
			return Cookies.get(cookieName) ? JSON.parse(Cookies.get(cookieName)) : {};
		},
		setSourceCookies: function () {
			var params = new URLSearchParams(window.location.search);
			var cookie = {};

			params.forEach(function (val, key) {
				cookie[key] = val;
			});

			cookie.referrer = document.referrer;
			cookie.landing_pg = window.location.href;

			// A page with no src/lp param (e.g. an organic pageview visited before
			// the tracked landing page) shouldn't be able to permanently claim
			// first-touch attribution ahead of a later page that actually carries one.
			var hasTrackingParams = params.has('src') || params.has('lp');
			var ftCookieName = this.settings.cookie.name.ft;
			var existingFt = Cookies.get(ftCookieName);
			var ftIsUntracked = true;

			if (typeof existingFt !== 'undefined') {
				try {
					var existingFtData = JSON.parse(existingFt);
					ftIsUntracked = !existingFtData.src && !existingFtData.lp;
				} catch (e) {
					ftIsUntracked = true;
				}
			}

			if (typeof existingFt === 'undefined' || (ftIsUntracked && hasTrackingParams)) {
				Cookies.set(ftCookieName, JSON.stringify(cookie), this.settings.cookie.opts);
			}

			Cookies.set(this.settings.cookie.name.lt, JSON.stringify(cookie), this.settings.cookie.opts);
		},
		populateFormFields: function () {
			if (!this.hasInit) {
				console.warn('SourceTracker has not been initialized. Please call init() before populating form fields.');
				return;
			}

			var cookieName = this.settings.cookie.name[this.settings.strategy];
			var vars = Cookies.get(cookieName) ? JSON.parse(Cookies.get(cookieName)) : {};
			var attr = this.settings.forms.prefillAttr;

			Object.keys(vars).forEach(function (key) {
				var fields = document.querySelectorAll('[' + attr + '="' + key + '"]');
				Array.prototype.forEach.call(fields, function (el) {
					el.value = vars[key];
				});
			});
		},
	};

	return module;
};

/**
 * Weekly business-hours schedule evaluated in the site's timezone.
 *
 * Rows are flattened into windows measured in minutes from Sunday 00:00, which
 * lets windows that run past midnight be compared the same way as any other.
 */
window.TrimarkBusinessHours = (function () {
	var WEEK = 7 * 1440;
	var WEEKDAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

	function toMinutes(value) {
		var parts = String(value || '').split(':');

		if (parts.length !== 2) {
			return null;
		}

		var hours = Number(parts[0]);
		var minutes = Number(parts[1]);
		var isValid =
			hours % 1 === 0 && minutes % 1 === 0 && hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59;

		return isValid ? hours * 60 + minutes : null;
	}

	function normalize(rows) {
		var windows = [];

		if (!Array.isArray(rows)) {
			return windows;
		}

		rows.forEach(function (row) {
			var start = toMinutes(row && row.start);
			var end = toMinutes(row && row.end);

			// Equal times would describe either a closed or a 24-hour window; the
			// field validation rejects them, so treat them as unusable here.
			if (start === null || end === null || start === end) {
				return;
			}

			var length = end > start ? end - start : end + 1440 - start;
			var days = Array.isArray(row.days) ? row.days : [];

			days.forEach(function (value) {
				var day = Number(value);

				if (day % 1 !== 0 || day < 0 || day > 6) {
					return;
				}

				windows.push({ opensAt: day * 1440 + start, length: length });
			});
		});

		return windows;
	}

	function nowInWeek(timeZone, when) {
		var date = when || new Date();

		// Sites set to a manual UTC offset rather than a city report "+05:00",
		// which Intl rejects. Those sites do not observe DST, so a fixed shift is
		// exact.
		var offset = /^([+-])(\d{2}):(\d{2})$/.exec(String(timeZone || ''));

		if (offset) {
			var shift = (Number(offset[2]) * 60 + Number(offset[3])) * (offset[1] === '-' ? -1 : 1);
			var shifted = new Date(date.getTime() + shift * 60000);

			return shifted.getUTCDay() * 1440 + shifted.getUTCHours() * 60 + shifted.getUTCMinutes();
		}

		try {
			var parts = new Intl.DateTimeFormat('en-US', {
				timeZone: timeZone,
				weekday: 'short',
				hour: '2-digit',
				minute: '2-digit',
				hourCycle: 'h23',
			})
				.formatToParts(date)
				.reduce(function (values, part) {
					values[part.type] = part.value;
					return values;
				}, {});

			if (!Object.prototype.hasOwnProperty.call(WEEKDAYS, parts.weekday)) {
				return null;
			}

			return WEEKDAYS[parts.weekday] * 1440 + (Number(parts.hour) % 24) * 60 + Number(parts.minute);
		} catch (error) {
			return null;
		}
	}

	return {
		normalize: normalize,

		/**
		 * @returns {boolean|null} null when the site timezone cannot be read.
		 */
		isOpen: function (windows, timeZone, date) {
			var now = nowInWeek(timeZone, date);

			if (now === null) {
				return null;
			}

			return windows.some(function (window) {
				return (now - window.opensAt + WEEK) % WEEK < window.length;
			});
		},

		/**
		 * @returns {number|null} Minutes until the schedule next opens or closes.
		 */
		minutesUntilChange: function (windows, timeZone, date) {
			var now = nowInWeek(timeZone, date);

			if (now === null) {
				return null;
			}

			var soonest = WEEK;

			windows.forEach(function (window) {
				[window.opensAt, window.opensAt + window.length].forEach(function (point) {
					var delta = (point - now + WEEK) % WEEK;

					if (delta > 0 && delta < soonest) {
						soonest = delta;
					}
				});
			});

			return soonest;
		},
	};
})();

/**
 * jQuery-free call tracking library.
 *
 * Initialize after TrimarkSourceTracker:
 * window.TrimarkCallTracker.init({
 *   swap: '(555) 555-5555',
 *   default: '(555) 555-1234',
 *   triggers: {
 *     src: {
 *       g: { phone: '(555) 555-9876', name: 'Google' },
 *     },
 *   },
 *   afterHours: {
 *     phone: '(555) 555-0000',
 *     timeZone: 'America/New_York',
 *     businessHours: [{ days: [1, 2, 3, 4, 5], start: '08:00', end: '17:00' }],
 *   },
 * });
 */
(function () {
	var CallTracker = function () {
		// Each anchor is rendered from its as-published markup, so a later update
		// can swap in a different number or put the original one back.
		var originals = new WeakMap();

		return {
			settings: {},
			schedule: [],
			boundaryTimer: null,
			init: function (settings) {
				if (typeof TrimarkSourceTracker === 'undefined') {
					console.warn('TrimarkSourceTracker is not initialized. CallTracker cannot function without it.');
					return;
				}

				this.settings = settings;
				this.schedule = settings.afterHours
					? TrimarkBusinessHours.normalize(settings.afterHours.businessHours)
					: [];

				this.updatePhones();
				this.watchBusinessHours();
			},
			getCallTrackingPhone: function () {
				var sourceCookie = TrimarkSourceTracker.getSourceData();
				var triggers = this.settings.triggers || {};
				var targetPhone = '';

				var triggerKeys = Object.keys(triggers);
				for (var i = 0; i < triggerKeys.length; i++) {
					var trigger = triggerKeys[i];
					if (sourceCookie.hasOwnProperty(trigger)) {
						// Case-insensitive match — same fix as assets-legacy/js/call-tracker.js.
						var cookieVal = String(sourceCookie[trigger]).toLowerCase();
						Object.keys(triggers[trigger]).forEach(function (key) {
							if (key.toLowerCase() === cookieVal) {
								targetPhone = triggers[trigger][key].phone;
							}
						});
						break;
					}
				}

				return targetPhone;
			},
			isAfterHours: function () {
				var afterHours = this.settings.afterHours;

				if (!afterHours || !afterHours.phone || !this.schedule.length) {
					return false;
				}

				// A null result means the timezone could not be read, in which case
				// the published number stands.
				return TrimarkBusinessHours.isOpen(this.schedule, afterHours.timeZone, new Date()) === false;
			},
			getTargetPhone: function () {
				if (this.isAfterHours()) {
					return this.settings.afterHours.phone;
				}

				var phone = this.getCallTrackingPhone();

				if (Cookies.get('trmk_is_paid') && phone === '') {
					phone = this.settings.default || '';
				}

				return phone;
			},
			updatePhones: function () {
				var swap = this.settings.swap;

				if (!swap) {
					return;
				}

				var phone = this.getTargetPhone();
				var telHref = phone ? 'tel:' + phone.replace(/\D/g, '') : null;

				var anchors = document.querySelectorAll('a');
				Array.prototype.forEach.call(anchors, function (el) {
					var original = originals.get(el);

					if (!original) {
						if (el.innerHTML.indexOf(swap) === -1) {
							return;
						}

						original = { html: el.innerHTML, href: el.getAttribute('href') };
						originals.set(el, original);
					}

					var html = phone ? original.html.split(swap).join(phone) : original.html;
					var href = telHref === null ? original.href : telHref;

					if (el.innerHTML !== html) {
						el.innerHTML = html;
					}

					if (href === null) {
						el.removeAttribute('href');
					} else if (el.getAttribute('href') !== href) {
						el.setAttribute('href', href);
					}
				});
			},
			watchBusinessHours: function () {
				var self = this;
				var afterHours = this.settings.afterHours;

				if (!afterHours || !this.schedule.length) {
					return;
				}

				var queueNextBoundary = function () {
					window.clearTimeout(self.boundaryTimer);

					var minutes = TrimarkBusinessHours.minutesUntilChange(
						self.schedule,
						afterHours.timeZone,
						new Date()
					);

					if (minutes === null) {
						return;
					}

					self.boundaryTimer = window.setTimeout(function () {
						self.updatePhones();
						queueNextBoundary();
					}, minutes * 60000 + 1000);
				};

				queueNextBoundary();

				// A backgrounded tab can have its timer throttled past the boundary.
				document.addEventListener('visibilitychange', function () {
					if (document.hidden) {
						return;
					}

					self.updatePhones();
					queueNextBoundary();
				});
			},
		};
	};

	window.TrimarkCallTracker = CallTracker();
})();


(function () {
	function whenJQuery(cb) {
		if (window.jQuery) {
			cb(window.jQuery);
			return;
		}

		var tries = 0;
		var timer = setInterval(function () {
			if (window.jQuery) {
				clearInterval(timer);
				cb(window.jQuery);
			} else if (++tries > 100) {
				clearInterval(timer);
			}
		}, 300);
	}

	function boot() {
		if (typeof Cookies === 'undefined') {
			console.warn('js-cookie is required for call tracking.');
			return;
		}

		var sourceTracker = window.TrimarkCreateSourceTracker({
			strategy: 'ft', // "ft" or "lt" (first-touch or last-touch)
			cookie: {
				name: {
					ft: 'trmk_src_first', // first touch attribution
					lt: 'trmk_src_last', // last touch attribution
				},
				opts: {
					expires: 1, // 1 day
					path: '/', // full site
				},
			},
			forms: {
				prefillAttr: 'data-prefill', // data attribute of form field to prefill
			},
		});
		sourceTracker.init();

		sourceTracker.populateFormFields();
		whenJQuery(function ($) {
			$(document).on('gform_post_render', function () {
				sourceTracker.populateFormFields();
			});
		});

		var configEl = document.getElementById('trmk-call-tracking-config');
		if (configEl && window.TrimarkCallTracker) {
			try {
				var config = JSON.parse(configEl.textContent);

				if (config.setPaidCookie) {
					Cookies.set('trmk_is_paid', '1', { expires: 1, path: '/' });
				}

				window.TrimarkCallTracker.init(config);
			} catch (e) {
				console.warn('Invalid call tracking config.', e);
			}
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
